/* Realizzandoo — Configuratore del collare personalizzabile (v3, schermata unica).
 *
 * Niente piu' quattro passi: colore e taglia si scelgono a vista, le lettere
 * stanno in un pannello OPZIONALE, e "Aggiungi al carrello" e' sempre attivo.
 * Il carrello resta a piu' righe: il collare, una riga per ogni combinazione
 * carattere+colore, e il guinzaglio se richiesto.
 *
 * OGNI CHARM HA IL SUO COLORE. Nel prodotto vero i nomi si compongono anche a
 * lettere di colori diversi, quindi ogni charm porta con se' il proprio colore:
 * la fila di swatch li cambia tutti insieme, toccando un charm si cambia solo
 * quello. Per questo lo stato tiene oggetti {c, col} e non semplici lettere.
 *
 * La taglia dei charm segue quella del collare e non si sceglie: le lettere L
 * non entrano in una cinghia S.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-rlz-collare-config]');
  if (!root) return;

  var D;
  try {
    D = JSON.parse(root.querySelector('[data-rlz-cc-data]').textContent);
  } catch (e) {
    return;
  }

  var MAX = parseInt(root.dataset.max, 10) || 8;
  var ALTEZZA_CHARM = 94;
  var ALTEZZA_MINIMA = 26;

  // charms: [{ c: 'L', col: 'VIOLA' }, ...]
  var state = { size: null, strap: null, charmColor: null, charms: [], leash: false };
  var apertoIndice = null;   // charm con il pannellino colore aperto

  var q = function (s) { return root.querySelector(s); };
  var qa = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

  var el = {
    total: q('[data-rlz-cc-total]'),
    name: q('[data-rlz-cc-name]'),
    counter: q('[data-rlz-cc-counter]'),
    charmsBox: q('[data-rlz-cc-charms]'),
    band: q('[data-rlz-cc-band]'),
    hint: q('[data-rlz-cc-hint]'),
    bar: q('[data-rlz-cc-bar]'),
    pop: q('[data-rlz-cc-pop]'),
    popTitle: q('[data-rlz-cc-pop-title]'),
    popColors: q('[data-rlz-cc-pop-colors]'),
    popRemove: q('[data-rlz-cc-pop-remove]'),
    pbCollar: q('[data-rlz-cc-pb-collar]'),
    pbCharmsRow: q('[data-rlz-cc-pb-charms-row]'),
    pbCharmsLabel: q('[data-rlz-cc-pb-charms-label]'),
    pbCharms: q('[data-rlz-cc-pb-charms]'),
    pbTotal: q('[data-rlz-cc-pb-total]'),
    pbTotalLabel: q('[data-rlz-cc-pb-total-label]'),
    error: q('[data-rlz-cc-error]'),
    leash: q('[data-rlz-cc-leash]'),
    persToggle: q('[data-rlz-cc-pers-toggle]'),
    persPanel: q('[data-rlz-cc-pers-panel]'),
    persTitle: q('[data-rlz-cc-pers-title]'),
    persSub: q('[data-rlz-cc-pers-sub]')
  };

  // I testi di riposo del bottone lettere: quando il pannello e' chiuso ma il
  // nome c'e', il bottone diventa il riassunto ("LUNA · +11,96 €").
  var persTitleBase = el.persTitle ? el.persTitle.textContent : '';
  var persSubBase = el.persSub ? el.persSub.textContent : '';

  var COLORI_CHARM = qa('[data-rlz-cc-charmcolor]').map(function (b) {
    return b.dataset.rlzCcCharmcolor;
  });

  // ---------- utilita' ----------

  var fmt = (function () {
    var locale = document.documentElement.lang || 'it';
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    try { return new Intl.NumberFormat(locale, { style: 'currency', currency: cur }); }
    catch (e) { return { format: function (n) { return n.toFixed(2) + ' ' + cur; } }; }
  })();
  function money(c) { return fmt.format((c || 0) / 100); }

  function imgFor(ch, col) { return D.img[ch + '|' + (D.colorCode[col] || '')] || ''; }
  function hexFor(col) { return D.hex[col] || '#ddd'; }
  function lettere() {
    return state.charms.filter(function (x) { return x.c.length === 1; })
                       .map(function (x) { return x.c; }).join('');
  }

  function segna(lista, attr, valore) {
    lista.forEach(function (b) { b.classList.toggle('is-selected', b.dataset[attr] === valore); });
  }

  // ---------- pannello lettere (aperto/chiuso) ----------

  function persAperto() { return el.persPanel && !el.persPanel.hidden; }

  function setPers(open) {
    if (!el.persPanel || !el.persToggle) return;
    el.persPanel.hidden = !open;
    el.persToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    el.persToggle.classList.toggle('is-open', open);
    if (!open) chiudiPop();
    // Ad apertura la banda passa da width 0 a piena: l'adattamento va rifatto.
    aggiorna();
    track('rlz_config_pers_toggle', { open: open, charms: state.charms.length });
  }

  if (el.persToggle) {
    el.persToggle.addEventListener('click', function () { setPers(!persAperto()); });
  }

  // ---------- anteprima ----------

  function disegnaAnteprima() {
    var box = el.charmsBox, band = el.band;
    if (box) {
      if (band) band.style.setProperty('--strap', hexFor(state.strap));
      box.innerHTML = '';
      state.charms.forEach(function (x, i) {
        var src = imgFor(x.c, x.col);
        if (!src) return;
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'rlz-cc__charm' + (apertoIndice === i ? ' is-open' : '');
        b.dataset.index = String(i);
        // Niente crocetta sul charm: quando il nome e' lungo i charm si
        // rimpiccioliscono e le crocette, di misura fissa, si accavallavano in
        // una fila di simboli sopra le lettere. Si tocca il charm e si apre il
        // pannellino, dove c'e' anche "Togli".
        b.innerHTML = '<img src="' + src + '" alt="' + x.c + '">';
        b.querySelector('img').addEventListener('load', adattaAnteprima, { once: true });
        box.appendChild(b);
      });
    }
    if (el.hint) el.hint.hidden = state.charms.length > 0;
    if (el.counter) el.counter.textContent = state.charms.length + '/' + MAX;
    if (el.bar) el.bar.hidden = state.charms.length === 0;

    var conta = {};
    state.charms.forEach(function (x) { if (x.c.length > 1) conta[x.c] = (conta[x.c] || 0) + 1; });
    qa('[data-rlz-cc-symbol-count]').forEach(function (badge) {
      var n = conta[badge.dataset.rlzCcSymbolCount] || 0;
      badge.textContent = String(n);
      badge.hidden = n === 0;
      badge.closest('.rlz-cc__symbol').classList.toggle('is-on', n > 0);
    });

    adattaAnteprima();
  }

  /* Il nome deve stare tutto dentro la cinghia. Su telefono la banda e' larga
   * poco piu' di 300px: con otto charm sborderebbe e resterebbe nascosto dietro
   * uno scorrimento laterale che nessuno pensa di fare. */
  function adattaAnteprima() {
    var box = el.charmsBox, band = el.band;
    if (!box || !band) return;
    box.style.removeProperty('--charm-h');
    if (!state.charms.length) return;
    // A pannello chiuso la banda misura zero: si riadatta alla riapertura.
    if (band.clientWidth === 0) return;
    var pronte = Array.prototype.every.call(box.querySelectorAll('img'), function (i) {
      return i.complete && i.naturalWidth > 0;
    });
    if (!pronte) return;

    // L'altezza di partenza si LEGGE, non si assume: su telefono il foglio di
    // stile parte da 54px invece che da 62, e calcolando sul valore desktop la
    // riduzione risultava nulla e il nome restava tagliato.
    var prima = box.querySelector('img');
    var hCorrente = prima ? prima.getBoundingClientRect().height : ALTEZZA_CHARM;
    var csBand = window.getComputedStyle(band);
    var disponibile = band.clientWidth - parseFloat(csBand.paddingLeft) - parseFloat(csBand.paddingRight);
    var naturale = box.scrollWidth;
    if (naturale > disponibile && naturale > 0 && hCorrente > 0) {
      // margine dell'1% per non restare incollati al bordo per un pixel
      var h = Math.max(ALTEZZA_MINIMA, Math.floor(hCorrente * (disponibile / naturale) * 0.99));
      box.style.setProperty('--charm-h', h + 'px');
    }
  }

  // ---------- pannellino del singolo charm ----------

  function apriPop(i) {
    if (!el.pop) return;
    apertoIndice = i;
    var x = state.charms[i];
    if (!x) return chiudiPop();

    el.popTitle.textContent = x.c.length === 1 ? x.c : x.c.toLowerCase();
    el.popColors.innerHTML = '';
    COLORI_CHARM.forEach(function (col) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'rlz-cc__pop-color' + (col === x.col ? ' is-on' : '');
      b.style.background = hexFor(col);
      b.title = col;
      b.setAttribute('aria-label', col);
      b.dataset.col = col;
      el.popColors.appendChild(b);
    });
    el.pop.hidden = false;
    disegnaAnteprima();
  }

  function chiudiPop() {
    apertoIndice = null;
    if (el.pop) el.pop.hidden = true;
    disegnaAnteprima();
  }

  if (el.popColors) {
    el.popColors.addEventListener('click', function (e) {
      var b = e.target.closest('.rlz-cc__pop-color');
      if (!b || apertoIndice === null) return;
      state.charms[apertoIndice].col = b.dataset.col;
      chiudiPop();
      aggiorna();
    });
  }
  if (el.popRemove) {
    el.popRemove.addEventListener('click', function () {
      if (apertoIndice === null) return;
      var tolto = state.charms.splice(apertoIndice, 1)[0];
      if (tolto && tolto.c.length === 1 && el.name) el.name.value = lettere();
      chiudiPop();
      nascondiErrore();
      aggiorna();
    });
  }

  root.addEventListener('click', function (e) {
    var b = e.target.closest('.rlz-cc__charm');
    if (!b) return;
    if (!b.closest('[data-rlz-cc-charms]')) return;
    var i = parseInt(b.dataset.index, 10);
    if (apertoIndice === i) chiudiPop(); else apriPop(i);
  });

  // ---------- tracking (dataLayer + CustomEvent; inerte finche' non c'e' un consumer) ----------

  function track(ev, params) {
    try {
      var p = { event: ev };
      for (var k in params) p[k] = params[k];
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(p);
      document.dispatchEvent(new CustomEvent(ev, { detail: params || {} }));
    } catch (e) { /* il tracking non deve mai rompere il configuratore */ }
  }

  (function () {
    function primo(e) {
      // Solo interazioni vere: gli eventi sintetici dell'init non sono un "inizio".
      if (e && e.isTrusted === false) return;
      root.removeEventListener('click', primo, true);
      root.removeEventListener('input', primo, true);
      track('rlz_config_start', {});
    }
    root.addEventListener('click', primo, true);
    root.addEventListener('input', primo, true);
  })();

  // ---------- prezzo ----------

  function conti() {
    var collare = D.prices.collar || 0;
    // Dal 1/9/2026 ogni charm si paga, lettere comprese: prezzo unitario dal
    // prodotto charm (D.prices.charm), conteggio su tutto il nome.
    var paganti = state.charms.length;
    var charms = (D.prices.charm || 0) * paganti;
    var guinz = state.leash && D.prices.leash ? D.prices.leash : 0;
    return { collare: collare, charms: charms, guinz: guinz, simboli: paganti, tutto: collare + charms + guinz };
  }

  function disegnaPrezzo() {
    var t = conti();
    if (el.total) el.total.textContent = money(t.tutto);

    if (el.pbCollar) el.pbCollar.textContent = money(t.collare);
    if (el.pbCharmsRow) {
      var n = t.simboli;
      el.pbCharmsRow.hidden = n === 0;
      if (n) {
        var etichetta = n === 1 ? D.labels.charmOne
                                : D.labels.charmMany.replace(/\{\{\s*n\s*\}\}/, n);
        el.pbCharmsLabel.textContent = etichetta + ' × ' + money(D.prices.charm);
        el.pbCharms.textContent = money(t.charms);
      }
    }
    if (el.pbTotal) el.pbTotal.textContent = money(t.tutto);
    if (el.pbTotalLabel) {
      // "Totale per MILO": il nome nel conto, senza aggiungere righe.
      if (!el.pbTotalLabel.dataset.base) el.pbTotalLabel.dataset.base = el.pbTotalLabel.textContent;
      var nomeTot = lettere();
      el.pbTotalLabel.textContent = nomeTot && D.labels.totalFor
        ? D.labels.totalFor.replace(/\{\{\s*name\s*\}\}/, nomeTot)
        : el.pbTotalLabel.dataset.base;
    }

    // Il bottone lettere racconta cosa c'e' dentro anche da chiuso.
    if (el.persTitle && el.persSub) {
      var nome = lettere();
      if (state.charms.length) {
        var testo = nome || (state.charms.length === 1 ? D.labels.charmOne
                          : D.labels.charmMany.replace(/\{\{\s*n\s*\}\}/, state.charms.length));
        el.persTitle.textContent = testo;
        // Le lettere sono comprese: il supplemento si mostra solo se c'e' davvero
        // un charm decorativo da pagare, altrimenti si dichiara che e' incluso.
        // A zero charm resta la riga del server (Fino a 8 lettere + prezzo):
      // e' la specifica di costo che deve vedersi PRIMA di digitare.
      if (!el.persSub.dataset.base) el.persSub.dataset.base = el.persSub.textContent;
      el.persSub.textContent = t.charms ? '+ ' + money(t.charms) : el.persSub.dataset.base;
      } else {
        el.persTitle.textContent = persTitleBase;
        el.persSub.textContent = persSubBase;
      }
    }

    // il banner rate (e chiunque ascolti) segue il totale composto, non il prezzo base
    document.dispatchEvent(new CustomEvent('rlz:composizione-change', { detail: { priceCents: t.tutto } }));
  }

  function aggiorna() {
    disegnaAnteprima();
    disegnaPrezzo();
  }

  // ---------- scelte ----------

  var bottoniTaglia = qa('[data-rlz-cc-size]');
  bottoniTaglia.forEach(function (b) {
    b.addEventListener('click', function () {
      state.size = b.dataset.rlzCcSize;
      segna(bottoniTaglia, 'rlzCcSize', state.size);
      var e = q('[data-rlz-cc-echo-size]');
      if (e) e.textContent = state.size;
      aggiorna();
    });
  });

  var bottoniCinghia = qa('[data-rlz-cc-strap]');
  bottoniCinghia.forEach(function (b) {
    b.addEventListener('click', function () {
      state.strap = b.dataset.rlzCcStrap;
      segna(bottoniCinghia, 'rlzCcStrap', state.strap);
      var e = q('[data-rlz-cc-echo-strap]');
      if (e) e.textContent = state.strap;
      evitaColoreUgualeAllaCinghia();
      aggiorna();
    });
  });

  var bottoniColoreCharm = qa('[data-rlz-cc-charmcolor]');
  bottoniColoreCharm.forEach(function (b) {
    b.addEventListener('click', function () {
      state.charmColor = b.dataset.rlzCcCharmcolor;
      segna(bottoniColoreCharm, 'rlzCcCharmcolor', state.charmColor);
      var e = q('[data-rlz-cc-echo-charmcolor]');
      if (e) e.textContent = state.charmColor;
      // La fila di swatch vale per tutti: e' il modo veloce di dare un colore
      // all'intero nome. Le eccezioni si fanno toccando il singolo charm.
      state.charms.forEach(function (x) { x.col = state.charmColor; });
      dipingiSimboli();
      chiudiPop();
      aggiorna();
    });
  });

  /* Lettere dello stesso colore della cinghia: il nome sparisce e l'anteprima non
   * dice piu' niente. Se capita, si sposta il colore delle lettere sul primo che
   * fa contrasto — resta cambiabile a mano, ma non si parte mai da rosa su rosa. */
  function evitaColoreUgualeAllaCinghia() {
    if (!state.strap || state.charmColor !== state.strap) return;
    var alternativo = COLORI_CHARM.filter(function (c) { return c !== state.strap; })[0];
    if (!alternativo) return;
    state.charmColor = alternativo;
    segna(bottoniColoreCharm, 'rlzCcCharmcolor', state.charmColor);
    var e = q('[data-rlz-cc-echo-charmcolor]');
    if (e) e.textContent = state.charmColor;
    state.charms.forEach(function (x) {
      if (x.col === state.strap) x.col = state.charmColor;
    });
    dipingiSimboli();
  }

  function dipingiSimboli() {
    qa('[data-rlz-cc-symbol]').forEach(function (b) {
      var img = b.querySelector('img');
      if (img) img.src = imgFor(b.dataset.rlzCcSymbol, state.charmColor);
    });
  }

  qa('[data-rlz-cc-symbol]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (state.charms.length >= MAX) { mostraErrore(D.labels.tooMany); return; }
      state.charms.push({ c: b.dataset.rlzCcSymbol, col: state.charmColor });
      nascondiErrore();
      aggiorna();
    });
  });

  if (el.name) {
    el.name.addEventListener('input', function () {
      // Solo A-Z: i charm esistono per le lettere, non per cifre o accenti.
      var lett = el.name.value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toUpperCase().replace(/[^A-Z]/g, '').split('');
      var simboli = state.charms.filter(function (x) { return x.c.length > 1; });
      var vecchie = state.charms.filter(function (x) { return x.c.length === 1; });
      var posti = Math.max(0, MAX - simboli.length);
      lett = lett.slice(0, posti);
      // Il colore gia' scelto per la lettera in quella posizione va tenuto:
      // riscrivere il nome non deve azzerare le tinte scelte a mano.
      state.charms = lett.map(function (c, i) {
        return { c: c, col: (vecchie[i] && vecchie[i].col) || state.charmColor };
      }).concat(simboli);
      if (el.name.value !== lett.join('')) el.name.value = lett.join('');
      chiudiPop();
      nascondiErrore();
      aggiorna();
    });
  }

  var svuota = q('[data-rlz-cc-clear]');
  if (svuota) {
    svuota.addEventListener('click', function () {
      state.charms = [];
      if (el.name) el.name.value = '';
      chiudiPop();
      nascondiErrore();
      aggiorna();
      if (el.name) el.name.focus();
    });
  }

  if (el.leash) {
    el.leash.addEventListener('change', function () {
      state.leash = el.leash.checked;
      track('rlz_leash_upsell', { action: el.leash.checked ? 'accepted' : 'declined' });
      aggiorna();
    });
  }

  // ---------- errori ----------

  function mostraErrore(msg, apriPannello) {
    // Gli errori sulle lettere hanno senso solo col pannello davanti agli occhi.
    if (apriPannello && !persAperto()) setPers(true);
    if (!el.error) { window.alert(msg); return; }
    el.error.textContent = msg;
    el.error.hidden = false;
    try { el.error.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } catch (e) {}
  }
  function nascondiErrore() { if (el.error) el.error.hidden = true; }

  // ---------- carrello ----------

  function costruisciRighe() {
    var idCollare = D.collar[state.size + '|' + state.strap];
    if (!idCollare) return null;

    var nome = lettere();
    // Con i colori per singolo charm l'elenco li dichiara uno per uno, cosi' in
    // magazzino si sa quale lettera va di che colore senza aprire l'ordine.
    var elenco = state.charms.map(function (x) {
      return x.c + ' (' + x.col.toLowerCase() + ')';
    }).join(' · ');

    var props = {};
    if (nome) props[D.labels.nameProp] = nome;
    if (elenco) props[D.labels.charmsProp] = elenco;

    var righe = [{ id: idCollare, quantity: 1, properties: props }];

    // Una riga per combinazione carattere+colore, con la quantita'.
    var conta = {};
    state.charms.forEach(function (x) {
      var k = x.c + '|' + x.col;
      conta[k] = (conta[k] || 0) + 1;
    });
    var perTaglia = D.charm[state.size] || {};
    var mancanti = [];
    Object.keys(conta).forEach(function (k) {
      var id = perTaglia[k];
      if (!id) { mancanti.push(k); return; }
      var p = {};
      p[D.labels.forProp] = nome || k.split('|')[0];
      righe.push({ id: id, quantity: conta[k], properties: p });
    });
    if (mancanti.length) return null;

    if (state.leash && D.leash) {
      var idG = D.leash[state.size + '|' + state.strap];
      if (!idG) return null;
      righe.push({ id: idG, quantity: 1 });
    }
    return righe;
  }

  var add = q('[data-rlz-cc-add]');
  if (add) {
    add.addEventListener('click', function () {
      nascondiErrore();
      // Il nome e' OPZIONALE: senza charm si compra il collare liscio.
      if (state.charms.length) {
        var contaLC = {};
        state.charms.forEach(function (x) { if (x.c.length === 1) { var k = x.c + '|' + x.col; contaLC[k] = (contaLC[k] || 0) + 1; } });
        if (Object.keys(contaLC).some(function (k) { return contaLC[k] > 3; })) {
          mostraErrore(D.labels.maxLetter || D.labels.tooMany, true); return;
        }
      }
      var righe = costruisciRighe();
      if (!righe) { mostraErrore(D.labels.unavailable); return; }

      if (state.charms.length) {
        var simboliN = state.charms.filter(function (x) { return x.c.length > 1; }).length;
        track('rlz_config_name_set', { letters: state.charms.length - simboliN, symbols: simboliN, value: conti().tutto / 100 });
      }

      add.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: righe })
      })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) {
            mostraErrore((res.body && res.body.description) || D.labels.generic);
            return;
          }
          document.dispatchEvent(new CustomEvent('rlz:cart-updated'));
          track('rlz_config_atc', {
            value: conti().tutto / 100,
            charms: state.charms.length,
            currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'
          });
          var drawer = document.querySelector('cart-drawer, [data-rlz-cart-drawer]');
          if (!drawer) {
            window.location.href = (window.Shopify && window.Shopify.routes
              ? window.Shopify.routes.root : '/') + 'cart';
            return;
          }
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
            document.querySelectorAll('.cart-count, .cart-item-count, [data-cart-count], #cart-icon-bubble .cart-count-bubble span:first-child').forEach(function (el) {
              el.textContent = cart.item_count;
            });
          }).catch(function () {});
          var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          fetch(rootPath + '?section_id=cart-drawer', { credentials: 'same-origin' })
            .then(function (r) { return r.text(); })
            .then(function (html) {
              var dom = new DOMParser().parseFromString(html, 'text/html');
              var fresh = dom.querySelector('cart-drawer');
              if (fresh) drawer.innerHTML = fresh.innerHTML;
              // il drawer nasce con is-empty se la pagina e' stata aperta a carrello
              // vuoto: dopo un'aggiunta va tolta, o il CSS lo tratta da carrello vuoto
              drawer.classList.remove('is-empty');
              drawer.classList.add('animate', 'active');
              document.body.classList.add('overflow-hidden');
            })
            .catch(function () { drawer.classList.add('animate', 'active'); });
        })
        .catch(function () { mostraErrore(D.labels.generic); })
        .finally(function () { add.disabled = false; });
    });
  }

  // ---------- guida taglie ----------

  var guida = q('[data-rlz-cc-guide]');
  if (guida) {
    guida.addEventListener('click', function () {
      var dlg = document.querySelector('[data-rlz-size-guide]');
      if (dlg && typeof dlg.showModal === 'function') dlg.showModal();
    });
  }

  // ---------- stima consegna (Ordinato → Spedito → Consegnato) ----------

  (function () {
    var o = q('[data-rlz-cc-eta-o]'), s = q('[data-rlz-cc-eta-s]'), d = q('[data-rlz-cc-eta-d]');
    if (!o || !s || !d || !D.prodDays) return;
    var f;
    try { f = new Intl.DateTimeFormat(document.documentElement.lang || 'it', { day: 'numeric', month: 'short' }); }
    catch (e) { f = { format: function (x) { return x.getDate() + '/' + (x.getMonth() + 1); } }; }
    // Giorni LAVORATIVI, come promette la pagina ("15 giorni lavorativi").
    function addLav(da, n) {
      var x = new Date(da.getTime());
      while (n > 0) {
        x.setDate(x.getDate() + 1);
        var g = x.getDay();
        if (g !== 0 && g !== 6) n--;
      }
      return x;
    }
    var oggi = new Date();
    o.textContent = f.format(oggi);
    var sped = addLav(oggi, D.prodDays[1] || 0);
    s.textContent = '~' + f.format(sped);
    if (D.shipDays && D.shipDays.length === 2) {
      var d1 = addLav(sped, D.shipDays[0] || 0);
      var d2 = addLav(sped, D.shipDays[1] || 0);
      d.textContent = f.format(d1) + ' – ' + f.format(d2);
    } else {
      d.textContent = '';
    }
  })();

  // ---------- avvio ----------

  if (bottoniTaglia[1]) bottoniTaglia[1].click();   // M: la taglia piu' comune
  if (bottoniColoreCharm[0]) bottoniColoreCharm[0].click();
  if (bottoniCinghia[0]) bottoniCinghia[0].click();  // per ultimo: sposta il colore lettere se coincide
  dipingiSimboli();
  aggiorna();
  window.addEventListener('resize', adattaAnteprima);
})();

